module.exports = __webpack_public_path__ + "static/media/oxy-grill.9b66241a.pdf";